import styles from './index.scss'
import xialaIco from './xiala_ico.png'
import { Button } from 'antd-mobile'
import React, { useState, FC } from 'react'
import iconSelected from './xuanzhong.png'
import iconUnSelected from './buxuanzhong.png'
import successSvg from './successSvg'
import { SvgRadioSuccessIcon } from '@/libs/components/Icon/svgIcon'
import { CheckCircleFill } from 'antd-mobile-icons'
import { TrackView } from '@dragonpass/intl-unified-tracker'

type DiscountCouponCardPropsType = {
  onConfirm?: () => void
  data: {
    expirationStart: string // 有效期开始
    expirationEnd: string // 有效期结束
    instructions: string // 使用说明
    couponType: 'discount' | 'reduce' // 优惠卷类型：折扣 discount  满减 reduce
    couBarriersAmount: number // 使用门槛
    cuoName: string //优惠券名称
    cuoMaxAmount: number // 最多优惠金额
    cuoDiscount: number // 折扣
  }
  color?: string
}

// 去使用的效果的优惠券
export default function DiscountCouponCard(props: DiscountCouponCardPropsType) {
  const { onConfirm = () => { }, data, color = '' } = props
  const {
    expirationStart,
    expirationEnd,
    instructions,
    couponType,
    couBarriersAmount,
    cuoName,
    cuoMaxAmount,
    cuoDiscount,
  } = data

  const [open, setOpen] = useState<any>(false)

  const DiscountsComponents: any = {
    discount: (
      <div className={styles.discounts}>
        <div className={styles.num}>
          {cuoDiscount}
          <span>折</span>
        </div>
        <div className={styles.condition}>满{couBarriersAmount}折</div>
      </div>
    ),
    reduce: (
      <div className={styles.discounts}>
        <div className={styles.num} style={{ color }}>
          {cuoDiscount}
          <span>元</span>
        </div>
        <div className={styles.condition}>满{Number(couBarriersAmount)}减</div>
      </div>
    ),
    quota: (
      <div className={styles.discounts}>
        <div className={styles.num} style={{ color }}>
          {cuoDiscount}
          <span>元</span>
        </div>
        <div className={styles.condition}>定额</div>
      </div>
    ),
  }

  return (
    <div className={styles.discountCouponCard}>
      <div className={styles.upperPart}>
        {DiscountsComponents[couponType]}
        <div className={styles.info}>
          <div className={styles.name}>{cuoName}</div>
          <div className={styles.date}>
            {expirationStart} 至 {expirationEnd}
          </div>
        </div>
      </div>
      <div className={styles.nextPart}>
        <div className={styles.explainTitle} onClick={() => setOpen(!open)}>
          使用说明
          <img
            src={xialaIco}
            className={`${styles.icon} ${open ? styles.open : ''}`}
          />
        </div>
        <Button
          className={styles.btn}
          shape="rounded"
          type="submit"
          color="primary"
          size="small"
          onClick={onConfirm}
        >
          去使用
        </Button>
      </div>
      <div
        className={styles.explainContent}
        style={{ display: open ? 'block' : 'none' }}
      >
        {!!cuoMaxAmount && couponType === 'discount' && (
          <>
            最高可优惠{cuoMaxAmount}元<br />
          </>
        )}
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: instructions }}
        ></div>
      </div>
    </div>
  )
}

type SelectDiscountCouponCardPropsType = {
  onSelect?: () => void
  data: {
    expirationStart: string // 有效期开始
    expirationEnd: string // 有效期结束
    instructions: string // 使用说明
    couponType: 'discount' | 'reduce' // 优惠卷类型：折扣 discount  满减 reduce
    couBarriersAmount: number // 使用门槛
    cuoName: string //优惠券名称
    cuoMaxAmount: number // 最多优惠金额
    cuoDiscount: number // 折扣
  }
  check?: boolean // 是否选中,
  containerStyles?: React.CSSProperties
  color?: string;
  categoryType?: string
  trackClk?: boolean
  trackExp?: boolean
  trackData?: {
    [key: string]: any
  }
}

// 勾选的效果的优惠券
export function SelectDiscountCouponCard(
  props: SelectDiscountCouponCardPropsType,
) {
  const { onSelect = () => { }, data, check, color = '', trackClk = false, trackExp = false, trackData = {} } = props
  const {
    expirationStart,
    expirationEnd,
    instructions,
    couponType,
    couBarriersAmount,
    cuoName,
    cuoMaxAmount,
    cuoDiscount,
  } = data

  const [open, setOpen] = useState<any>(false)

  const CheckIco = (props: any) => {
    const { check } = props
    return !!check ? (
      <CheckCircleFill
        style={{ color: props?.color || 'var(--certify-primary-color)' }}
        fontSize={20}
      />
    ) : (
      <img src={iconUnSelected} className={styles.icon} />
    )
  }

  const DiscountsComponents: any = {
    discount: (
      <div className={styles.discounts}>
        <div className={styles.num}>
          {cuoDiscount}
          <span>折</span>
        </div>
        <div className={styles.condition}>满{couBarriersAmount}折</div>
      </div>
    ),
    reduce: (
      <div className={styles.discounts}>
        <div className={styles.num} style={{ color }}>
          {cuoDiscount}
          <span>元</span>
        </div>
        <div className={styles.condition}>满{Number(couBarriersAmount)}减</div>
      </div>
    ),
    quota: (
      <div className={styles.discounts}>
        <div className={styles.num} style={{ color }}>
          {cuoDiscount}
          <span>元</span>
        </div>
        <div className={styles.condition}>定额</div>
      </div>
    ),
  }

  return (
    <div className={styles.discountCouponCard} style={props?.containerStyles}>
      <TrackView
        trackData={trackData}
        trackClk={trackClk}
        trackExp={trackExp}
      >
        <div className={styles.upperPart} onClick={onSelect}>
          {DiscountsComponents[couponType]}
          <div className={styles.info}>
            <div className={styles.name}>{cuoName}</div>
            <div className={styles.date}>
              {expirationStart} 至 {expirationEnd}
            </div>
          </div>
          <CheckIco check={check} {...props} />
        </div>
      </TrackView>
      <div className={styles.nextPart}>
        <div className={styles.explainTitle} onClick={() => setOpen(!open)}>
          使用说明
          <img
            src={xialaIco}
            className={`${styles.icon} ${open ? styles.open : ''}`}
          />
        </div>
      </div>
      <div
        className={styles.explainContent}
        style={{ display: open ? 'block' : 'none' }}
      >
        {!!cuoMaxAmount && couponType === 'discount' && (
          <>
            最高可优惠{cuoMaxAmount}元<br />
          </>
        )}
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: instructions }}
        ></div>
      </div>
    </div>
  )
}
